__webpack_require__.p = "/ma/fr/customer-service/returns-claims/spareparts/";